import { render, staticRenderFns } from "./exprotData.vue?vue&type=template&id=58bef268&scoped=true"
import script from "./exprotData.vue?vue&type=script&lang=js"
export * from "./exprotData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bef268",
  null
  
)

export default component.exports